import { render, staticRenderFns } from "./ComplianceGauge.vue?vue&type=template&id=09bf696c&scoped=true"
import script from "./ComplianceGauge.vue?vue&type=script&lang=js"
export * from "./ComplianceGauge.vue?vue&type=script&lang=js"
import style0 from "./ComplianceGauge.vue?vue&type=style&index=0&id=09bf696c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf696c",
  null
  
)

export default component.exports